var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useCallback, useEffect } from "react";
import { useRecoilState } from "recoil";
import { HistoryAtom, HistoryStepNumberAtom } from "../utils/context";
import { useBoard } from "./useBoard";
export function useHistory() {
    var _a = useBoard(), resetBoard = _a.resetBoard, workingBoard = _a.workingBoard, updateCurrentBoard = _a.updateCurrentBoard, currentBoard = _a.currentBoard;
    var _b = useRecoilState(HistoryAtom), history = _b[0], setHistory = _b[1];
    var _c = useRecoilState(HistoryStepNumberAtom), stepNumber = _c[0], setStepNumber = _c[1];
    /**
     * Update history
     */
    useEffect(function () {
        if (!currentBoard.equals(history[stepNumber])) {
            setHistory(__spreadArray(__spreadArray(__spreadArray([], history.slice(0, stepNumber + 1), true), [
                currentBoard
            ], false), history.slice(stepNumber + 2), true));
            setStepNumber(function (step) { return step + 1; });
        }
    }, [setHistory, setStepNumber, history, currentBoard]);
    /**
     * Undo the most recent action.
     * If there is no action to undo, do nothing.
     *
     * As soon as we commit a new action, we cut off any actions
     * in front of the current action in the action history.
     */
    var undoAction = useCallback(function () {
        if (stepNumber === 0)
            return;
        resetBoard(history[stepNumber - 1]);
        setStepNumber(stepNumber - 1);
    }, [history, resetBoard, stepNumber, setStepNumber]);
    var redoAction = useCallback(function () {
        if (stepNumber === history.length - 1)
            return;
        resetBoard(history[stepNumber + 1]);
        setStepNumber(stepNumber + 1);
    }, [history, resetBoard, stepNumber, setStepNumber]);
    var cleanHistory = useCallback(function () {
        setHistory(function (history) { return history.slice(0, stepNumber + 2); });
    }, [setHistory, stepNumber]);
    var resetHistory = useCallback(function () {
        resetBoard(history[0]);
        setHistory([history[0]]);
        setStepNumber(0);
    }, [setHistory, resetBoard, setStepNumber, history]);
    var canUndo = useCallback(function () { return stepNumber > 0; }, [stepNumber]);
    var canRedo = useCallback(function () { return stepNumber < history.length - 1; }, [stepNumber, history]);
    return {
        stepNumber: stepNumber,
        setStepNumber: setStepNumber,
        undoAction: undoAction,
        redoAction: redoAction,
        cleanHistory: cleanHistory,
        resetHistory: resetHistory,
        canUndo: canUndo(),
        canRedo: canRedo(),
        historySize: history.length
    };
}
